import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import '@/index.css';
import { Router } from '@/router';
import App from '@/App';

const container = document.getElementById('root');
const tree = (
  <Router>
    <App />
  </Router>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
